import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";

import { BatchesModel } from "common/models/page-models/Batches/batches-data-model";
import { BatchesMetaModel } from "common/models/page-models/Batches/batches-form-meta-model";
import { BatchesFormDataService } from "common/services/data-services/admin/batches/batches-form-data.services";



@Injectable({
    providedIn: 'root'
})
export class BatchesFormWidgetService extends FormWidgetService<BatchesModel> {
    constructor(protected ds: BatchesFormDataService) {
        super(ds);
    }



    getMetaModel(): MetaModel {
        const meta = new BatchesMetaModel();
        return meta.getMetaModel();
    }

    // override prepareMetaModel(dataModel: BatchesModel, metaModel: BatchesMetaModel, routeData: WidgetModel, event = null): Promise<BatchesMetaModel> {
    //     return new Promise<BatchesMetaModel>((resolve, reject) => {
    //         console.log(event,'prepareMetaModel')
    //         console.log(dataModel,'dataModel')

    //         if (event !== null && event.fieldType === 'datepicker' && event.field_Name === 'duration_start') {
    //             const startDate = dataModel['duration_start'];
    //             if (startDate) {
    //               const startYear = new Date(startDate).getFullYear();
    //               const endDate = new Date(startDate);
    //               endDate.setFullYear(startYear + 4);  
        
    //               console.log(metaModel['properties']['duration_end']);
    //               metaModel['properties']['duration_end'].propmaxDate = endDate;  
    //             }
    //           }
        
    //           if (dataModel.duration_start) {
    //             const startDate = new Date(dataModel.duration_start);
    //             const startYear = startDate.getFullYear();
    //             const endDate = new Date(startDate);  
    //             endDate.setFullYear(startYear + 4);   
        
    //             metaModel.properties.duration_end.propmaxDate = endDate;
    //           }
        
    //           if (dataModel.id === undefined || dataModel.id === null) {
    //             dataModel.id = 0;
    //           }else {
    //             // Keep the existing id if it's already defined (i.e., when editing a batch)
    //             dataModel.id = dataModel.id;
    //           }
    //           metaModel.pageTitle = (dataModel.id !== 0) ? 'Update Batch' : 'Add Batch';
        
    //           resolve(metaModel);
    //         });
    //       }
        }

       


        /**
         *  setEndDate(event) {
    if (event !== null && event.field_Name === 'duration_end') {
      const startDate = new Date(this.initForm.value.duration_start).getTime();
      const endDate = new Date(this.initForm.value.duration_end).getTime();
 
      if (endDate < startDate || endDate === startDate) {
        this.initForm.patchValue({
          duration_end: '',
        });
      }

    

      
    } else {
      this.ws
        .prepareMetaModel(
          this.initForm.value,
          this.pageMeta,
          this.pageWidget,
          event
        )
        .then((data: any) => {});
    }
  }  While adding it works but at the time of editing it doest work....End date should be for 4 years only
         */